import { useLocales } from '@shared/locales'
import { TablePaginationConfig } from 'antd'
import { PaginationConfig } from 'antd/es/pagination'

import { useQueryUpdate } from './useQueryUpdate'

export type PaginationTypes<T> = {
  count?: number
  current_page?: number
  total_pages?: number
  per_page?: number
  page_size?: number
  results?: T
}

export const defaultPageSizeOptions = ['10', '20', '50', '100']

export const usePaginationConfigCrm = <T>(
  paginatedData?: PaginationTypes<T>,
  defaultPageSize?: number
): TablePaginationConfig => {
  const { t } = useLocales()
  const { params, updateQuery } = useQueryUpdate()

  const pageSize =
    defaultPageSize ??
    paginatedData?.per_page ??
    paginatedData?.page_size ??
    (Number(params.page_size) || 10)
  const currentPage = paginatedData?.current_page ?? (Number(params.page) || 1)

  const showTotal = (total: number) => {
    const start = (currentPage - 1) * pageSize + 1
    const end = Math.min(currentPage * pageSize, total)

    return t('pagination.total', { from: start, to: end, total })
  }

  const onChange = (page: number, pageSize: number) => {
    updateQuery({
      ...params,
      page,
      page_size: pageSize,
      per_page: pageSize
    })
  }

  return {
    position: ['bottomRight'],
    total: paginatedData?.count,
    pageSize,
    current: currentPage,
    hideOnSinglePage: false,
    showTotal,
    showSizeChanger: true,
    locale: { items_per_page: '' },
    onChange
  }
}

export const usePaginationListConfig = <T>(
  list?: PaginationTypes<T>
): PaginationConfig => {
  return {
    total: list?.count,
    pageSize: list?.per_page,
    current: list?.current_page,
    pageSizeOptions: defaultPageSizeOptions
  }
}
